export const selectUser = state => state.user;

export const selectUserId = state => state.user && state.user.userId;

export const selectUserProgress = state =>
  state.user && state.user.userProgress;

export const selectUserIsPasswordSubmitted = state =>
  state.user && state.user.isPasswordSubmitted;

export const selectUserLoginToken = state => {
  const user = selectUser(state);

  return user && user.loginToken;
};

export const selectUserMyPayWaitlist = state =>
  state.user && state.user.myPayWaitlist;

export const selectUserReferrerFirstName = state =>
  state.user && state.user.referrerFirstName;

export const selectUserReferredBy = state =>
  state.user && state.user.referredBy;

export const selectUserIsConnected = state =>
  state.user && state.user.userIsConnected;
